(() => {
  function getVisibleQuantity() {
    let total = 0;
    document.querySelectorAll('cart-items input.quantity__input, #main-cart-items input.quantity__input').forEach((input) => {
      const value = parseInt(input.value, 10);
      if (Number.isFinite(value) && value > 0) total += value;
    });
    return total;
  }

  function campaignCopy(qty) {
    if (qty >= 15) {
      return { title: '%40 indirimin aktif', subtitle: 'En avantajlı fiyat seviyesine ulaştınız.', progress: 100, mid: true, max: true };
    }
    if (qty >= 4) {
      const remaining = 15 - qty;
      return {
        title: '%35 indirimin aktif',
        subtitle: remaining + ' ürün daha ekle, %40 indirim seviyesine ulaş.',
        progress: 26.67 + (qty - 4) * (73.33 / 11),
        mid: true,
        max: false
      };
    }
    const remaining = Math.max(0, 4 - qty);
    return {
      title: remaining + ' ürün daha ekle, %35 indirimi kazan',
      subtitle: 'Sepetinizi tamamlayın, adet başına daha avantajlı fiyatı yakalayın.',
      progress: (qty / 4) * 26.67,
      mid: false,
      max: false
    };
  }

  function renderCampaign(qty) {
    const safeQty = Math.max(0, Number(qty) || 0);
    const copy = campaignCopy(safeQty);

    document.querySelectorAll('[data-pv-campaign]').forEach((card) => {
      card.dataset.qty = String(safeQty);
      const title = card.querySelector('[data-pv-title]');
      const subtitle = card.querySelector('[data-pv-subtitle]');
      const progress = card.querySelector('[data-pv-progress]');
      const step4 = card.querySelector('[data-pv-step4]');
      const step15 = card.querySelector('[data-pv-step15]');
      if (title) title.textContent = copy.title;
      if (subtitle) subtitle.textContent = copy.subtitle;
      if (progress) progress.style.width = Math.max(0, Math.min(100, copy.progress)) + '%';
      if (step4) step4.classList.toggle('is-active', copy.mid);
      if (step15) step15.classList.toggle('is-active', copy.max);
      card.classList.toggle('is-max', copy.max);
    });

    const banner = document.getElementById('pv-kampanya-banner');
    if (banner) {
      if (safeQty >= 15) {
        banner.textContent = '✅ 15+ ürün kampanyası aktif: %40 indirim';
        banner.style.display = 'block';
      } else if (safeQty >= 4) {
        banner.textContent = '✅ 4+ ürün kampanyası aktif: %35 indirim';
        banner.style.display = 'block';
      } else {
        banner.style.display = 'none';
      }
    }
  }

  function renderFromInputs() {
    const qty = getVisibleQuantity();
    if (qty > 0) renderCampaign(qty);
  }

  function refreshFromCart() {
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then((response) => response.json())
      .then((cart) => renderCampaign(cart.item_count))
      .catch(() => renderFromInputs());
  }

  function syncCampaign() {
    renderFromInputs();
    window.setTimeout(refreshFromCart, 250);
    window.setTimeout(refreshFromCart, 700);
  }

  document.addEventListener('DOMContentLoaded', syncCampaign);
  document.addEventListener('input', (event) => {
    if (event.target.matches('input.quantity__input')) renderFromInputs();
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('input.quantity__input')) syncCampaign();
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('quantity-input .quantity__button, cart-remove-button')) {
      window.setTimeout(renderFromInputs, 30);
      window.setTimeout(syncCampaign, 180);
    }
  });
  document.addEventListener('cart:updated', syncCampaign);

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, syncCampaign);
  }

  const observer = new MutationObserver(() => window.setTimeout(renderFromInputs, 20));
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
